import { KeyboardEvent, useState, useRef } from 'react';
import Image from 'next/image';
import styled from 'styled-components';
import beTwMerge from '@/utils/beTwMerge';

const SearchInput = styled.input``;

export interface ISearchBar {
  placeholder: string;
  onClick: (event: any) => void;
  className?: string;
  hasError?: boolean;
  isMobile?: boolean;
}

export default function SearchBar({ placeholder, onClick, className, hasError, isMobile }: ISearchBar) {
  const [searchWord, setSearchWord] = useState('');
  const searchRef = useRef<any>(null);

  const handlKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      if (isMobile) {
        searchRef?.current?.blur();
      }

      onClick(searchWord);
    }
  };

  const handleForm = e => {
    e.preventDefault();
  };

  return (
    <div className={beTwMerge('tw-w-full tw-relative', className)}>
      <form method="get" action="/" onSubmit={handleForm}>
        <div className={beTwMerge(hasError && 'is-error', 'tw-relative tw-w-full')}>
          <SearchInput
            ref={searchRef}
            value={searchWord}
            type="text"
            placeholder=" "
            id={placeholder}
            onKeyDown={handlKeyDown}
            onChange={e => setSearchWord(e.target.value)}
            className={beTwMerge(
              'border-normal tw-peer tw-block tw-h-10 tw-w-full tw-appearance-none tw-rounded-none tw-border tw-border-gray tw-bg-transparent tw-pl-2 tw-pr-10 tw-pb-0 tw-pt-4 tw-text-sm/5 tw-outline-none tw-outline-0 focus:tw-border-darkGrey focus:tw-ring-[0.5px] focus:tw-ring-inset focus:tw-ring-darkGrey group-[.is-error]:tw-border-error group-[.is-error]:tw-ring-error tw-font-book'
            )}
          />
          <label
            htmlFor={placeholder}
            className="tw-pointer-events-none tw-absolute tw-left-2 tw-top-2.5 tw-origin-[0] -tw-translate-y-2 tw-scale-75 tw-transform tw-text-sm tw-font-normal tw-text-grey500 tw-duration-300 group-[.is-error]:!tw-text-error peer-placeholder-shown:tw-translate-y-0 peer-placeholder-shown:tw-scale-100 peer-placeholder-shown:tw-text-darkGrey peer-focus:-tw-translate-y-2 peer-focus:tw-scale-75 peer-focus:tw-text-grey500 tw-font-book"
          >
            {placeholder}
          </label>
          <button
            className="border-normal tw-border-1 tw-absolute tw-right-0 tw-top-0 tw-h-10 tw-appearance-none tw-rounded-none tw-bg-transparent tw-p-2.5 tw-text-sm tw-text-darkGrey tw-outline-none focus:tw-outline-none"
            type="submit"
            onClick={() => onClick(searchWord)}
            aria-label="Search"
          >
            <svg
              aria-hidden="true"
              className="tw-h-4 tw-w-4"
              fill="none"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
            </svg>
          </button>
        </div>
      </form>
    </div>
  );
}
